import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ForgetPassword from "../ForgetPassword";
import SignUp1 from "../signup/SignUp1";
import { FaFacebookSquare, FaWindowClose } from "react-icons/fa";
import { ImGoogle2 } from "react-icons/im";
import axios from "axios";

const LogIn1 = ({ closeModal }) => {
  const history = useHistory();
  const [user, setUser] = useState({ email: "", password: "" });

  const { email, password } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const PostData = async () => {
    const response = await axios
      .post("/api/v1/auth/login", { email, password })
      .then((response) => {
        console.log(response.data);
        console.log(response.data.user);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        history.push("/buystakes");
      })
      .catch((err) => console.log(err.response.data.error));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log("Login");
  };

  const clickHandler = () => {
    closeModal(false);
  };

  const [openFP, setOpenFP] = useState(false);

  const forgotpasswordClickHandler = () => {
    setOpenFP(!openFP);
  };

  const [openSign, setOpenSign] = useState(false);

  const signupClickHandler = () => {
    setOpenSign(!openSign);
  };
  return (
    <div className="logModal">
      <div id="LogIn" className="py-5">
        <div className="m-5 pt-5 modalMargin" style={{ width: "110%" }}>
          <div
            className="d-flex justify-content-end mt-5 pt-5"
            onClick={clickHandler}
          >
            <button
              type="button"
              class="btn-close shadow-none"
              aria-label="Close"
            ></button>
          </div>
          <div className="text-center">
            <div className="d-block">
              <img
                src="/assests/logo2.png"
                alt="KIBI Sport"
                className="fluid-img"
              />
            </div>

            <h1 className="mt-4 mb-4 modalHeader">Log In</h1>
            <form onSubmit={onSubmit}>
              <input
                type="email"
                name="email"
                value={email}
                onChange={onChange}
                placeholder="User Name or Email Address"
                className="input-group p-3 rounded border border-secondary"
              />
              <br />
              <input
                type="password"
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                className="input-group p-3 rounded border border-secondary"
              />
              <br />
              <div>
                <button
                  className="loginBtn p-3 rounded mb-4"
                  onClick={PostData}
                >
                  Log In
                </button>
              </div>
            </form>

            <div className="d-md-flex justify-content-between align-items-center gap-5 textLink ">
              <div>
                <p className="textMute">Don't have account?</p>
                <a
                  onClick={signupClickHandler}
                  style={{ cursor: "pointer" }}
                  className="textBlue"
                >
                  Create new account
                </a>
              </div>

              <p
                style={{ cursor: "pointer" }}
                onClick={forgotpasswordClickHandler}
                className="text-dark"
              >
                Forgot password
              </p>
            </div>
            <p className="fw-bold text-secondary fs-4">OR</p>
            <div className="d-flex justify-content-center align-items-center gap-1">
              <FaFacebookSquare color="#395998" size={45} />
              <ImGoogle2 color="#EA4335" size={40} />
            </div>
          </div>
        </div>
      </div>
      {openFP && <ForgetPassword closeModal={setOpenFP} />}
      {openSign && <SignUp1 closeModal={setOpenSign} />}
    </div>
  );
};

export default LogIn1;
